<template>
    <div>
        <rkm-area
            type="fieldset"
            title="Filtros"
        >
            <rkm-form ref="Form">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :max-date="data.form.dataAtual"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="data.form.exames"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="loadFields('exameId')"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">

                        <rkm-form-select
                            :options="data.form.localColeta"
                            label="Local de coleta"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.coletaUnidadeId"
                            value-field="id"
                            defaultOptionText="Todas"
                            @change="loadFields('coletaUnidadeId')"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="coletaInfraestruturas"
                            textField="nome"
                            v-model="model.coletaInfraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="loadFields('coletaInfraestruturaId')"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="data.form.laboratorios"
                            label="Laboratório"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.laboratorioId"
                            value-field="id"
                            defaultOptionText="Todos"
                            @change="loadFields('laboratorioId')"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="laboratorioInfraestruturas"
                            textField="nome"
                            v-model="model.laboratorioInfraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="loadFields('laboratorioInfraestruturaId')"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="data.form.ocupacoes"
                            default-option-text="Todos"
                            label="Ocupação"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                            @change="loadFields('ocupacaoId')"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="data.form.profissionais"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.profissionalId"
                            value-field="id"
                            @change="loadFields('profissionalId')"
                        />
                    </rkm-col>

                    <rkm-col cols="4">

                        <rkm-form-input-autocomplete
                            :repository="repositories.exame.procedimento"
                            :search-fields="fieldsProcedimento"
                            :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                            :request-query-string-params="requestQueryStringParamsUsuarioProcedimento"
                            label="Procedimento"
                            v-model="model.procedimento"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="data.form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="descricao"
                            v-model="model.statusId"
                            value-field="id"
                            @change="loadFields('statusId')"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Idade de"
                            number
                            v-model="model.idadeDe"
                            :validations="model.idadeAte ? validations.idadeDe : {}"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Idade até"
                            number
                            v-model="model.idadeAte"
                            :validations="model.idadeDe ? validations.idadeAte : {}"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave && itemsNotSave.length > 0"
            title="Totalizador geral de procedimentos"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-alert color="secondary">
                        <b>
                            {{ getTotalQuantidade() }}
                        </b>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave && itemsNotSave.length > 0"
            title="Resultado"
        >
            <template v-slot:trailing>

                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    cols="1"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <template v-if="itemsNotSave && itemsNotSave.length > 0">
            <div
                v-for="(item, index) in itemsNotSave"
                class="mt-3"
                :key="index"
            >
                <template>
                    <div class="table-th text-center coleta">
                        Unidade de coleta: {{ item.coletaNomeFantasia }} -
                        Local de atendimento: {{ item.coletaInfraestruturaNome }}
                    </div>
                </template>

                <template>
                    <div class="table-th text-center laboratorio">
                        Laboratório: {{ item.laboratorioNomeFantasia }} -
                        Local de atendimento: {{ item.laboratorioInfraestruturaNome }}
                    </div>
                </template>

                <rkm-table
                    :items="item.exames"
                    :fields="fields"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                    hide-filters
                    hide-pagination
                    class="table-agendamento"
                >
                    <template #afterTable>
                        <div class="table-th text-right">
                            Total de procedimentos: {{  item.total }}
                        </div>
                    </template>
                </rkm-table>
            </div>
        </template>

        <rkm-table v-if="searchList && itemsNotSave && itemsNotSave.length === 0"
            :items="itemsNotSave"
            :fields="fields"
            hide-filters
            sort-by="nome"
            hide-pagination
            class="table-agendamento"
        />

        <ModalPreferenciaImpressao ref="ModalPreferenciaImpressao" @orientation="updateOrientation"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Components
import ModalPreferenciaImpressao from '@/components/geral/impressao/Modal'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    components:{ ModalPreferenciaImpressao },
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        requestQueryStringParamsUsuarioProcedimento() {
            const request = this.clone(this.model)

            request.periodo.start = moment(this.model.periodo.start).format('YYYY-MM-DD')
            request.periodo.end = moment(this.model.periodo.end).format('YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(request)
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                idadeDe: {
                    max_value: this.model.idadeAte,
                },
                idadeAte: {
                    min_value: this.model.idadeDe,
                },
            }
        },
        coletaInfraestruturas(){

            if (!this.data.form.localColeta) {
                return [];
            }

            let infraestruturasOrigem = []
            let infraestruturas = this.data.form.localColeta

            if (this.model.coletaUnidadeId) {
                infraestruturas = infraestruturas.filter(unidade => unidade.id === this.model.coletaUnidadeId)
            }

            infraestruturas.map(infraestrutura => {

                infraestrutura.infraestruturas.map(unidade => {

                    let existe = infraestruturasOrigem.find(u => u.id === unidade.id)

                    if(!existe){

                        infraestruturasOrigem.push({

                            id: unidade.id,
                            nome: unidade.nome,
                            principal: unidade.principal,
                        })
                    }
                })
            })

            this.setInfraestruturaColeta(infraestruturasOrigem)

            return infraestruturasOrigem
        },
        laboratorioInfraestruturas(){

            if (!this.data.form.laboratorios) {
                return [];
            }

            let infraestruturasOrigem = []
            let infraestruturas = this.data.form.laboratorios

            if (this.model.laboratorioId) {
                infraestruturas = infraestruturas.filter(unidade => unidade.id === this.model.laboratorioId)
            }

            infraestruturas.map(infraestrutura => {

                infraestrutura.infraestruturas.map(unidade => {

                    let existe = infraestruturasOrigem.find(u => u.id === unidade.id)

                    if(!existe){

                        infraestruturasOrigem.push({

                            id: unidade.id,
                            nome: unidade.nome,
                            principal: unidade.principal,
                        })
                    }
                })
            })

            this.setInfraestruturaLaboratorio(infraestruturasOrigem)

            return infraestruturasOrigem
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.relatorioQuantitativoProducao'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        },
        this.load();
    },
    data() {
        return {
            model: {
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                laboratorioId: null,
                laboratorioInfraestruturaId: null,
                exameId: null,
                statusId: null,
                ocupacaoId: null,
                profissionalId: null,
                procedimemto: null,
                exameNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
                idadeDe: null,
                idadeAte: null
            },
            sortBy: 'nome',
            sortDesc: false,
            agendamentoExame: [],
            unidadeColeta: [],
            unidadeLaboratorio: [],
            itemsNotSave: [],
            items: [],
            enums: {
                preferenciaNome
            },
            indeterminate: false,
            filterDefault: {},
            selectedAll: false,
            columns: [
                { key: 'procedimentoCodigo', label: 'Código do procedimento', class: 'col-min', sortable: true, fixed: true },
                { key: 'procedimentoNome', label: 'Descrição do procedimento', class: 'col-min', sortable: true, fixed: false },
                { key: 'nome', label: 'Exame', sortable: true, fixed: true },
                { key: 'status', label: 'Status', sortable: true, fixed: true },
                { key: 'profissional', label: 'Profissional', sortable: true, fixed: false },
                { key: 'ocupacaoCodigo', label: 'CBO', sortable: true, fixed: true },
                { key: 'ocupacaoNome', label: 'Descrição do CBO', sortable: true, fixed: false },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', sortable: true, fixed: true },
            ],
            selectedCols: [],
            searchList: false,
            fieldMap: [
                'exameId',
                'coletaUnidadeId',
                'coletaInfraestruturaId',
                'laboratorioId',
                'laboratorioInfraestruturaId',
                'ocupacaoId',
                'profissionalId',
                'procedimento',
                'statusId',
            ],
            fieldsProcedimento: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
            orientation: ''
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'inicio' || key === 'fim') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        load() {

            this.model.periodo = this.data.form.periodo
            this.addWatchers()
            this.$nextTick(() => this.loadFields('periodo'))
        },
        print() {

            this.$refs.ModalPreferenciaImpressao.open();
            this.$refs.ModalPreferenciaImpressao.$once('completed', () => {

                this.setLoading()

                this.repositories.impressao.relatorioQuantitativoProducao(this.prepareDataWithColumns())
                    .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                    .finally(() => this.unsetLoading())
            })

        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioQuantitativoProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        updateOrientation(value) {
            this.orientation = value;
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            data.orientation = this.orientation

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            if (this.model.exameId) {

                data.exameNome = this.data.form.exames.find(u => u.id == this.model.exameId).nome
            }

            if (data.coletaUnidadeId) {

                data.coletaUnidadeNome = this.data.form.localColeta.find(u => u.id == data.coletaUnidadeId).nomeFantasia
            }

            if (data.coletaInfraestruturaId) {

                data.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == data.coletaInfraestruturaId).nome
            }

            if (data.laboratorioId) {

                data.laboratorioNome = this.data.form.laboratorios.find(u => u.id == data.laboratorioId).nomeFantasia
            }

            if (data.laboratorioInfraestruturaId) {

                data.laboratorioInfraestruturaNome = this.laboratorioInfraestruturas.find(u => u.id == data.laboratorioInfraestruturaId).nome
            }

            if (data.ocupacaoId) {

                data.ocupacaoNome = this.data.form.ocupacoes.find(u => u.id == data.ocupacaoId).nome
            }

            if (data.profissionalId) {

                data.profissionalNome = this.data.form.profissionais.find(u => u.id == data.profissionalId).nome
            }

            if (data.statusId) {

                data.statusNome = this.data.form.status.find(u => u.id == data.statusId).descricao
            }

            data.procedimentoCodigo = data.procedimento ? data.procedimento.codigo : null

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = Object.values(data.model.unidadeColeta);
                    this.searchList = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            params.procedimentoCodigo = params.procedimento ? params.procedimento.codigo : null

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exameId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.itemsNotSave = []
            this.searchList = false,

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = []
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.filter(item => item.disabled !== true).map(c => c.key) : []
        },
        setInfraestruturaColeta(infraestruturasOrigem) {

            if (this.model.coletaUnidadeId !== null) {

                const unidadePrincipal = infraestruturasOrigem.find(unidade => unidade.principal);

                if (unidadePrincipal) {

                    this.model.coletaInfraestruturaId = unidadePrincipal.id;
                } else if (infraestruturasOrigem.length === 1) {

                    this.model.coletaInfraestruturaId = infraestruturasOrigem[0].id;
                }
            }
        },
        setInfraestruturaLaboratorio(infraestruturasOrigem) {

            if (this.model.laboratorioId !== null) {

                const unidadePrincipal = infraestruturasOrigem.find(unidade => unidade.principal);

                if (unidadePrincipal) {

                    this.model.laboratorioInfraestruturaId = unidadePrincipal.id;
                } else if (infraestruturasOrigem.length === 1) {

                    this.model.laboratorioInfraestruturaId = infraestruturasOrigem[0].id;
                }
            }
        },
        loadFields(field) {

            this.setFields(field)

            this.setLoading()

            this.repositories.exame.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.$emit('handleFields', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setFields(value) {

            this.isSearch = false

            const index = this.fieldMap.indexOf(value) + 1;

            for (let i = index; i < this.fieldMap.length; i++) {

                const field = this.fieldMap[i];

                if (this.model[field] !== null) {

                    this.$set(this.model, field, null);
                }
            }

            this.setListagem()
        },
        getTotalQuantidade() {

            return this.itemsNotSave.reduce((sum, element) => {

                sum = sum + Number(element.total);
                return sum;

            },0)
        },
        addWatchers() {

            this.$watch('model.periodo.start', function () {

                if(this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields('periodo')
                }
            })

            this.$watch('model.periodo.end', function () {

                if(this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields('periodo')
                }
            })
        },
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.procedimento': function(){

            this.loadFields('procedimento')
        },
        selectedCols(newValue) {

        this.selectedAll = newValue.length > 0
            && newValue.length == this.optionalColumns.filter(item => item.disabled !== true).length

        this.indeterminate = newValue.length > 0
            && newValue.length != this.optionalColumns.filter(item => item.disabled !== true).length
        },
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-agendamento >>> .col-width {
    width: 16%;
}
.coleta {
    background: #e9e9e9;
}
.laboratorio {
   background: #dddddd;
}
</style>